<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small :title="'گزارش تضامین'" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-if="!hideDateRange" v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
								<div class="text-center">
									<v-btn v-if="!hideDateRange" color="primary" small dark class="mx-1" @click="loadData">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<v-btn v-if="hideDateRange" color="primary" fab outlined small class="mx-1" @click="loadData">
								<v-icon>mdi-refresh</v-icon>
							</v-btn>
							<export-excel :items="filteredItems" :headers="headers" :fileName="excelFileName">
							</export-excel>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<v-card v-for="filter in filters" :key="filter.type" class="rounded-xl mb-2 w-100" :color="`${filter.color} lighten-4`" elevation="0">
								<div class="d-flex align-center w-100 px-2">
									<span class="pointer" @click="assuranceTypeFilter = filter.enumType" :class="[`${filter.color}--text`]" style="padding: 5px 10px;border-radius: 20px;min-width: 50px;">{{ filter.type }}</span>
									<div class="flex-wrap d-flex align-center mr-1" style="flex-grow: 2;">
										<v-chip v-for="detail in filter.details" :key="detail.title" color="grey lighten-4" size="x-small" dense class="ma-1">
											<small>{{ detail.title }}</small>
											<v-badge color="grey lighten-1" :content="detail.count" inline />
											<small>{{ detail.other }}</small>
										</v-chip>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="8">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div class="info--text"><small>شماره وام: {{ row.item.userLoanCode }}</small></div>
												<div class="grey--text"><small>{{ row.item.loanTitle }}</small></div>
											</div>
										</td>
										<td>
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div><small>{{ row.item.memberFullName }}</small></div>
												<div class="grey--text"><small>کد ملی: {{ row.item.memberNationalCode }}</small></div>
												<div class="grey--text"><small>موبایل: {{ row.item.memberMobile }}</small></div>
											</div>
										</td>
										<td class="text-center">
											{{ row.item.userLoanAmount.toString().toPriceFormat() }}
											<div class="success--text">
												{{ row.item.userLoanPayableAmount.toString().toPriceFormat() }}
											</div>
										</td>
										<td class="text-center">
											{{ row.item.installmentAmount.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											<small>{{ convertAssuranceType(row.item.assuranceType) }}</small>
										</td>
										<td class="text-right">
											<div v-if="row.item.assuranceType === 1 || row.item.assuranceType === 2">
												<div class="red--text"><small>{{ row.item.assurancePersonFullName }}</small></div>
												<div class="grey--text"><small>سازمان: {{ row.item.organizationName }}</small></div>
												<div class="grey--text"><small>کد ملی: {{ row.item.assurancePersonNationalCode }}</small></div>
												<div class="grey--text"><small>شماره پرسنلی: {{ row.item.assurancePersonalCode }}</small></div>
											</div>
											<div v-if="row.item.assuranceType === 3">
												<div class="red--text"><small>مبلغ: {{ String(row.item.cheque.price).toPriceFormat() }}</small></div>
												<div class="grey--text"><small>نام و نام خانوادگی صاحب چک: {{ row.item.assurancePersonFullName }}</small></div>
												<div class="grey--text"><small>کد ملی صاحب چک: {{ row.item.assurancePersonNationalCode }}</small></div>
												<div class="grey--text d-flex flex-wrap" style="column-gap: 15px;">
													<small>تاریخ چک: {{ row.item.cheque.dueDate_Persian.date }}</small>
													<small>شماره چک: {{ row.item.cheque.chequeNumber }}</small>
													<small>شماره صیادی: {{ row.item.cheque.sayadiId }}</small>
												</div>
												<div class="grey--text d-flex flex-wrap" style="column-gap: 15px;">
													<div class="grey--text"><small>وصول شده؟ {{ row.item.cheque.isCollected ? 'بلی' : 'خیر' }}</small></div>
													<div class="grey--text"><small>عودت شده؟ {{ row.item.cheque.isReturned ? 'بلی' : 'خیر' }}</small></div>
												</div>
											</div>
											<div v-if="row.item.assuranceType === 4">
												<div class="red--text">
													<small>{{ row.item.coinType ? 'تعداد' : 'وزن' }}: {{ row.item.goldWeight }} {{ row.item.coinType ? 'عدد' : 'گرم' }}</small>
													<small v-if="row.item.coinType" class="mr-1">{{coinTypes.find(x => x.id === row.item.coinType).title}}</small>
													<div v-if="row.item.isReturned" class="success--text d-flex">
														<v-icon x-small color="success">mdi-check</v-icon>
														<small>عودت شده</small>
													</div>
												</div>
											</div>
											<div>
												<div v-if="row.item.description" class="grey--text pointer" @click="showDescription(row.item.description)"><small>مشاهده توضیحات</small></div>
											</div>

										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDescription" scrollable max-width="500px">
			<v-card>
				<v-card-title>
					<div><span class="headline">توضیحات ضمانت</span></div>
					<v-spacer />
					<v-btn @click="dialogDescription = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<p class="">{{ description }}</p>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { sumBy } from 'lodash'

	export default {
		name: 'OrganizationDueDated',
		props: {
			hideDateRange: { type: Boolean, default: false },
			memberId: { type: Number, default: 0 }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			// 'manage-loan': import('@/views/admin/ManageLoan.vue'),
			ManageLoan,
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				dialogDescription: false,
				description: '',
				dialogLoansManager: false,
				selectedMember: {},
				errorMessages: '',
				startDate: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'اطلاعات وام',
						align: 'center',
						sortable: true,
						value: 'userLoanCode',
						width: '170'
					}, {
						text: 'اطلاعات مشتری',
						align: 'start',
						sortable: true,
						value: 'memberFullName',
						width: '150'
					}, {
						text: 'موبایل',
						align: ' d-none',
						sortable: true,
						value: 'memberMobile',
					}, {
						text: 'عنوان وام',
						align: ' d-none',
						sortable: true,
						value: 'loanTitle',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'userLoanAmount'
					}, {
						text: 'قابل پرداخت',
						align: ' d-none',
						sortable: true,
						value: 'userLoanPayableAmount'
					}, {
						text: 'مبلغ اقساط',
						align: 'center',
						sortable: true,
						value: 'installmentAmount',
					}, {
						text: 'نوع ضمانت',
						align: 'center',
						sortable: true,
						value: 'assuranceType',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = this.convertAssuranceType(value.assuranceType)
							return text
						}
					}, {
						text: 'اطلاعات ضمانت',
						align: 'center',
						sortable: true,
						value: 'organizationName',
					}
				],
				items: [],
				dateRange: { start: '', end: '' },
				organizations: [],
				assuranceTypeFilter: [],
				coinTypes: [{ id: 0, title: '-' }, { id: 1, title: 'ربع سکه' }, { id: 2, title: 'نیم سکه' }, { id: 3, title: 'تمام بهار' }, { id: 4, title: 'گرمی پارسیان و ...' }]
			}
		},
		computed: {
			excelFileName() {
				let name = 'گزارش تضامین'
				if (this.startDate)
					name += ' از ' + this.startDate.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!this.assuranceTypeFilter.length)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				clonedItems = clonedItems.filter(x => this.assuranceTypeFilter.includes(x.assuranceType))

				return clonedItems
			},
			filters() {
				let result = []
				const prepareCheques = () => {
					let cheque = { type: 'چک', enumType: [3], details: [], color: 'purple' }
					let items = this.items.filter(x => x.assuranceType === 3)
					if (items?.length) {
						cheque.details.push({ title: 'تعداد کل:', count: items.length || '0', other: `مجموع: ${String(sumBy(items, (x) => x.cheque.price)).toPriceFormat()}` })
						cheque.details.push({ title: 'عودت شده:', count: items.filter(x => x.cheque.isReturned).length || '0', other: `مجموع: ${String(sumBy(items.filter(x => x.cheque.isReturned), (x) => x.cheque.price)).toPriceFormat()}` })
						cheque.details.push({ title: 'وصول شده:', count: items.filter(x => x.cheque.isCollected).length || '0', other: `مجموع: ${String(sumBy(items.filter(x => x.cheque.isCollected), (x) => x.cheque.price)).toPriceFormat()}` })
						cheque.details.push({ title: 'صندوق:', count: items.filter(x => !x.cheque.isCollected && !x.cheque.isReturned).length || '0', other: `مجموع: ${String(sumBy(items.filter(x => !x.cheque.isCollected && !x.cheque.isReturned), (x) => x.cheque.price)).toPriceFormat()}` })

						result.push(cheque)
					}
				}
				const prepareGolds = () => {
					let gold = { type: 'طلا', enumType: [4], details: [], color: 'orange' }
					let items = this.items.filter(x => x.assuranceType === 4)
					if (items?.length) {
						var coinTypeGroups = _.countBy(items.filter(x => x.coinType !== 0), x => x.coinType) //0=unknown
						var coins = Object.keys(coinTypeGroups).map(key => `${this.coinTypes.find(c => c.id == key)?.title}: ${sumBy(items.filter(x => x.coinType == key), (x) => x.goldWeight || 1)}`).join(' , ')
						gold.details.push({ title: 'تعداد کل:', count: items.length || '0', other: `وزن: ${sumBy(items.filter(x => x.coinType === 0), (x) => x.goldWeight)}    ${coins}` })

						gold.details.push({ title: 'عودت شده:', count: items.filter(x => x.isReturned).length || '0', other: `وزن: ${sumBy(items.filter(x => x.isReturned && x.coinType === 0), (x) => x.goldWeight)}` })

						coinTypeGroups = _.countBy(items.filter(x => !x.isReturned && x.coinType !== 0), 'coinType')
						coins = Object.keys(coinTypeGroups).map(key => `${this.coinTypes.find(c => c.id == key)?.title}: ${sumBy(items.filter(x => x.coinType == key && !x.isReturned), (x) => x.goldWeight || 1)}`).join(' , ')
						gold.details.push({ title: 'صندوق:', count: items.filter(x => !x.isReturned).length || '0', other: `وزن: ${sumBy(items.filter(x => !x.isReturned && x.coinType === 0), (x) => x.goldWeight)}    ${coins}` })

						result.push(gold)
					}
				}
				const prepareOrganizations = () => {
					let organization = { type: 'گواهی', enumType: [1, 2], details: [], color: 'blue' }
					let items = this.items.filter(x => x.assuranceType === 1 || x.assuranceType === 2)
					if (items?.length) {
						organization.details.push({ title: 'تعداد کل:', count: items.length || '0', other: `` })
						organization.details.push({ title: 'عودت شده:', count: items.filter(x => x.isReturned).length || '0', other: `` })
						organization.details.push({ title: 'صندوق:', count: items.filter(x => !x.isReturned).length || '0', other: `` })

						result.push(organization)
					}
				}
				const prepareOthers = () => {
					let other = { type: 'سایر', enumType: [0], details: [], color: 'green' }
					let items = this.items.filter(x => x.assuranceType === 0)
					if (items?.length) {
						other.details.push({ title: 'تعداد کل:', count: items.length || '0', other: `` })
						other.details.push({ title: 'عودت شده:', count: items.filter(x => x.isReturned).length || '0', other: `` })
						other.details.push({ title: 'صندوق:', count: items.filter(x => !x.isReturned).length || '0', other: `` })

						result.push(other)
					}
				}
				prepareCheques()
				prepareGolds()
				prepareOrganizations()
				prepareOthers()

				return result
			}
		},
		created() {

		},
		mounted() {
			if (this.memberId)
				this.loadData()
		},
		methods: {
			showDescription(description) {
				this.description = description
				this.dialogDescription = true
			},
			manageLoans(item) {
				this.selectedMember = { id: item.memberId, fullName: item.memberFullName, nationalCode: item.memberNationalCode, mobile: item.memberMobile, userName: item.memberUserName }
				this.dialogLoansManager = true
			},
			loadData() {
				this.loading = true
				this.assuranceTypeFilter = []
				api.get('admin/report/Assurances/?start=' + this.dateRange.start + '&end=' + this.dateRange.end + '&memberId=' + this.memberId, {})
					.then(
						response => {
							this.items = response
							this.organizations = Object.values(
								response.reduce((acc, obj) => ({ ...acc, [obj.organizationId]: { id: obj.organizationId, title: obj.organizationName } }), {})
							)
							if (this.organizations.length) {
								this.organizations.push({ id: 'همه', title: 'همه' })
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			convertAssuranceType(type) {
				switch (type) {
					case 0:
						return 'سایر'
					case 1:
						return 'سازمان خود شخص'
					case 2:
						return 'سازمانی دیگران'
					case 3:
						return 'چک'
					case 4:
						return 'طلا'
				}
			}
		},
	}
</script>
<style></style>
